import { Link } from "react-router-dom";
import { Anime, formatViews } from "@/mocks/anime";

type AnimeCardProps = {
  anime: Anime;
  rank?: number;
};

export default function AnimeCard({ anime, rank }: AnimeCardProps) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-[5/7] overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title}动漫封面`}
          title={`${anime.title} - 妖精动漫作品介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 top-0 p-2.5 flex items-start justify-between">
          <span className="px-2 py-0.5 rounded-md bg-primary-950/85 text-background-50 text-[11px] font-semibold">
            {anime.status}
          </span>
          <span className="px-2 py-0.5 rounded-md bg-accent-500 text-primary-950 text-[11px] font-bold flex items-center gap-0.5">
            <i className="ri-star-fill text-[10px]" />
            {anime.rating.toFixed(1)}
          </span>
        </div>
        {rank !== undefined && (
          <span className="absolute left-0 bottom-0 px-2.5 py-1 bg-primary-900/90 text-background-50 text-[12px] font-black">
            TOP {rank}
          </span>
        )}
        <div className="absolute inset-0 bg-primary-950/55 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <span className="w-11 h-11 rounded-full bg-accent-500 text-primary-950 flex items-center justify-center">
            <i className="ri-play-fill text-xl leading-none" />
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-[14px] font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {anime.title}
        </h3>
        <p className="mt-1.5 text-[12px] text-foreground-500 line-clamp-2 leading-5 min-h-[40px]">{anime.summary}</p>
        <div className="mt-2.5 flex items-center justify-between text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" />
            {formatViews(anime.views)}
          </span>
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 font-medium">{anime.type}</span>
        </div>
      </div>
    </Link>
  );
}